import { render, staticRenderFns } from "./OrderExtraConfigIframe.vue?vue&type=template&id=60083d62&"
import script from "./OrderExtraConfigIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderExtraConfigIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports